export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos"])},
          "total_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])}
        }
      },
      "en": {
        "labels": {
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fields"])},
          "total_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspections"])}
        }
      }
    }
  })
}